<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="id">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户名称" @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="内容" prop="id">-->
<!--                <a-input v-model="queryParam.content" placeholder="请输入内容" @pressEnter="handleQuery" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="分类" prop="category">
                <a-select v-model="queryParam.category">
                  <a-select-option v-for="(item, key) in categoryList" :key="index" :value="item.id">{{
                    item.categoryName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="话题" prop="talk">-->
<!--                <a-select v-model="queryParam.talk">-->
<!--                  <a-select-option v-for="(item, key) in talkList" :key="index" :value="item.id">{{-->
<!--                    item.label-->
<!--                  }}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="是否行业干货" prop="isRecommend">-->
<!--                <a-select v-model="queryParam.isRecommend" placeholder="请选择是否行业干货">-->
<!--                  <a-select-option :value="1">是</a-select-option>-->
<!--                  <a-select-option :value="0">否</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="是否新闻" prop="isRecommend">-->
<!--                <a-select v-model="queryParam.isNow" placeholder="请选择是否新闻">-->
<!--                  <a-select-option :value="1">是</a-select-option>-->
<!--                  <a-select-option :value="0">否</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="动态标题" prop="title">
                <a-input v-model="queryParam.title" placeholder="请输入动态标题" allow-clear/>
              </a-form-item>
            </a-col>
<!--          <template v-if="advanced">-->
<!--             -->
<!--            </template>-->
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div> -->
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!--     :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <div slot="category" slot-scope="text, record">
          <span v-for="item in record.category">{{ item }} </span>
        </div>

        <span slot="isRecommend" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmRecommendNews(record, record.isRecommend, null)"
            @cancel="cancelRecommendNews()"
          >
            <span slot="title">
              <b>{{ record.isRecommend == 1 ? '取消行业干货' : '确认加入行业干货' }} </b>?
            </span>
            <a-switch checked-children="是" un-checked-children="否" :checked="record.isRecommend == 1" />
          </a-popconfirm>
        </span>

        <span slot="isNews" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmRecommendNews(record, null, record.isNews)"
            @cancel="cancelRecommendNews()"
          >
            <span slot="title">
              <b>{{ record.isNews == 1 ? '取消精华帖' : '是精华帖' }} </b>?
            </span>
            <a-switch checked-children="是" un-checked-children="否" :checked="record.isNews == 1" />
          </a-popconfirm>
        </span>

        <span slot="isDraft" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmRecommendNews(record, null,null, record.isDraft)"
            @cancel="cancelRecommendNews()"
          >
            <span slot="title">
              <b>{{ record.isDraft == 1 ? '取消评论' : '开启评论' }} </b>?
            </span>
            <a-switch checked-children="是" un-checked-children="否" :checked="record.isDraft == 1" />
          </a-popconfirm>
        </span>收藏

        <span slot="operation" slot-scope="text, record, index">

          <a-popconfirm
                            :title="record.isTop==0?'确定要置顶该记录吗？':'确定要取消置顶该记录吗？'"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="handleSticky(record)"
                          >
                         <!-- <a-icon type="pushpin"/> snippets -->
                            <a href="javascript:void(0)"><a-icon type="pushpin"/>{{record.isTop==0?'置顶':'取消置顶'}}</a>
                          </a-popconfirm>
<!--          <a @click="$refs.createForm.handleInfo(record, undefined)" v-hasPermi="['dynamics:info:query']">-->
<!--            <a-icon type="search" />修改-->
<!--          </a>-->
          <br>

          <a @click="viewComment(record)" v-hasPermi="['comment:comment:list']" v-if="type!='tk'"> <a-icon type="search" />查看评论 </a>
          <a-divider type="vertical" v-hasPermi="['comment:comment:list']" />

          <a @click="handleDelete(record, index)" v-hasPermi="['dynamics:info:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageInfo, listInfo, delInfo, updateInfo,editTop} from '@/api/dynamics/info'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listTalk } from '@/api/dynamics/talk'
import { listCategory } from '@/api/dynamic/category'

export default {
  name: 'Info',
  components: {
    CreateForm,
  },
  props:["type"],
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      index: 0,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      talkList: [],
      categoryList: [],
      // 查询参数
      queryParam: {
        isRecommend: null,
        nickname: null,
        userId: null,
        type: null,
        content: null,
        linkAddress: null,
        categoryId: null,
        talk: null,
        id: null,
        emoticonId: null,
        location: null,
        longitude: null,
        latitude: null,
        visibleType: null,
        invisibleIds: null,
        likeNum: null,
        isDraft: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: '编号',
        //   dataIndex: 'id',
        //   // ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '动态类型',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '帖子标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '动态内容',
        //   dataIndex: 'content',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '图片，视频地址',
        //   dataIndex: 'linkAddress',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '分类',
        //   dataIndex: 'categoryStr',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '话题',
        //   dataIndex: 'talkStr',
        //   ellipsis: true,
        //   align: 'center',
        // },

        // {
        //   title: '城市',
        //   dataIndex: 'location',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '是否行业干货',
          dataIndex: 'isRecommend',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'isRecommend' },
        },
        {
          title: '是否精华贴',
          dataIndex: 'isNews',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'isNews' },
        },
        {
          title: '是否关闭评论',
          dataIndex: 'isDraft',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'isDraft' },
        },
        // {
        //   title: '可见类型',
        //   dataIndex: 'visibleType',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '不可见人ID',
        //   dataIndex: 'invisibleIds',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '评论数',
          dataIndex: 'commentNum',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width:100
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  mounted() {
      if(this.type!='tk'){
        this.getList()
      }
    this.intTalkCategory()
  },
  activated() {
    this.intTalkCategory()
  },

  computed: {},
  watch: {},

  methods: {
    handleSticky(record){
      var postData = {
        id:record.id,
        top:record.isTop==0?1:0
      }
      editTop(postData).then(res=>{
        if(res.code=='20001'){
          // this.$message.success("操作成功")
          this.getList()
        }else{
          this.$message.error("操作失败")
        }
      })
    },
    goList(record, type) {
      var this_ = this
      this_.$nextTick(() => {
        console.log('22')
        this_.queryParam.userId = record.id
        this_.queryParam.type = type
        this_.list = []
        this_.total = 0
        this_.current = 0
        this_.size = 0
        this_.getList()//这是我自定义的
      })
    },
    /** 查询日常、打卡动态列表 */
    getList() {
      this.loading = true
      this.list = []
      this.total = 0
      this.current = 0
      this.size = 0
      pageInfo(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    viewComment(record) {
      this.$router.push({ path: '/article/dynamics/info/comment', query: { dynamicsId: record.id } })
    },
    intTalkCategory() {
      listCategory({ isDeleted: 0 }).then((res) => {
        this.categoryList = res.data
      })
      listTalk({ isDeleted: 0 }).then((res) => {
        this.talkList = res.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        type: undefined,
        content: undefined,
        linkAddress: undefined,
        categoryId: undefined,
        talk: undefined,
        emoticonId: undefined,
        location: undefined,
        longitude: undefined,
        latitude: undefined,
        visibleType: undefined,
        invisibleIds: undefined,
        likeNum: undefined,
        isDraft: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      // 列表顶部删除indexs
      if (this.selectedRowKeys.length) {
        const indexList = this.selectedRowKeys.map((item) => {
          return this.list.findIndex((i) => i.id === item)
        })
        this.indexs = indexList
          .filter((item) => item !== -1)
          .map((ind) => {
            return (this.current - 1) * this.size + ind + 1
          })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row, index) {
      var index = index
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if (row.id) {
            data.push({ id: row.id })
          } else {
            that.ids.map((id) => data.push({ id: id }))
          }
          return delInfo(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          // that.ids = []
        },
      })
    },

    confirmRecommendNews(record, isRecommend, isNews,isDraft) {
      if (null != isRecommend) {
        isRecommend = isRecommend == 1 ? 0 : 1
      }
      if (null != isNews) {
        isNews = isNews == 1 ? 0 : 1
      }
      if (null != isDraft) {
        isDraft = isDraft == 1 ? 0 : 1
      }
      console.log("1111",isDraft)
      updateInfo({ id: record.id, isRecommend: isRecommend, isNews: isNews ,isDraft:isDraft}).then((res) => {
        this.$message.success('操作成功')
        this.getList()
      })
    },


    cancelRecommendNews() {},

    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'dynamics/info/export',
            {
              ...that.queryParam,
            },
            `日常、打卡动态_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
